import { createContext } from "react";

const CategoriasContext = createContext();

export default CategoriasContext;
